import { render, staticRenderFns } from "./ProductGroupSoldTable.vue?vue&type=template&id=42074868&"
import script from "./ProductGroupSoldTable.vue?vue&type=script&lang=js&"
export * from "./ProductGroupSoldTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupSoldTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
